export default {
  titles: {
    all_orders: 'All orders',
    left_to_pay: 'Left to pay',
    no_orders: 'All orders will be listed here',
  },
};